// extracted by css-extract-rspack-plugin
export default {"cls1":"Comments-cls1_GfN","cls2":"Comments-cls2_ckq Comments-cls1_GfN"};